
import { Inputs,validationSchema } from '@/entities/Games/GameFormInputs'
import { SideBar} from '@/entities/Games/GamesMapSideBar'

const GameFormMap = {
	Plural: 'Games',
	Single: 'Game',
	IsPage: false,
	Inputs: Inputs,	
	SideBar: SideBar,	
	ValidationSchema: validationSchema,
	
};

export default GameFormMap;
